// Import polyfills. Must be imported before all other dependencies.
import 'babel-polyfill';

// Import third party libraries.
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';
import { ApolloProvider } from 'react-apollo';
import ReactGA from 'react-ga';

import MaintenanceMode from 'containers/MaintenanceMode';

// Import root app.
import App from 'containers/App';

import Admin from 'containers/Admin/AdminLoadable';

// Import registerServiceWorker (from create-react-app).
//import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';

// Import ErrorBoundary which catches errors and sends them to Airbrake.
import ErrorBoundary from 'containers/ErrorBoundary';

// Import function to create our configured Apollo Client.
import configureApollo from './configureApollo';

import configureStore from './configureStore';

import registerScalingListener from 'utils/registerScalingListener';

import { configureZopim } from 'utils/zopim';

import createSoundRegistry from './sounds';

// Import global styles.
import './index.css';

// Register event listeners for handling screen scaling.
registerScalingListener(document, window);
// Register zendesk chat widget.
configureZopim(document, window);

// Create redux store with history and sound data.
const initialState = {};
export const history = createHistory();
const sounds = createSoundRegistry();
const store = configureStore(initialState, history, sounds);
const MOUNT_NODE = document.getElementById('root');

if (process.env.NODE_ENV === 'production') {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_CODE);
}

// Create Apollo client.
const apolloClient = configureApollo(history);

const render = () => {
  ReactDOM.render(
    process.env.NODE_ENV === 'production' ? (
      <ErrorBoundary>{app()}</ErrorBoundary>
    ) : (
      app()
    ),
    MOUNT_NODE
  );
};

function app() {
  return (
    <Provider store={store}>
      <ApolloProvider client={apolloClient}>
        <ConnectedRouter history={history}>
          <MaintenanceMode>
            <Switch>
              <Route path="/admin" component={Admin} />
              <Route component={App} />
            </Switch>
          </MaintenanceMode>
        </ConnectedRouter>
      </ApolloProvider>
    </Provider>
  );
}

if (module.hot) {
  // Hot reloadable React components files
  // modules.hot.accept does not accept dynamic dependencies,
  // have to be constants at compile-time
  module.hot.accept(['./containers/App', './containers/Admin'], () => {
    ReactDOM.unmountComponentAtNode(MOUNT_NODE);
    render();
  });
}

render();

//registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/index.js